module.exports = __webpack_public_path__ + "img/网站3-34.1a9d1abe.png";